<template>
  <h3>A propos de nous</h3>
  <div class="about">
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam, repellat
      repellendus obcaecati, praesentium officia quasi vitae dicta ad qui quos
      doloremque enim facilis itaque. Laudantium cupiditate vel nisi cum
      aliquid.
    </p>
    <p>
      Quibusdam, beatae porro, facere iusto ad, aliquam cum quasi harum ipsa
      ullam autem pariatur est aperiam repudiandae quis itaque voluptas omnis!
      Veritatis, quos magnam sequi iste officiis aspernatur corrupti rem.
    </p>
    <p>
      Reprehenderit earum dolorem eum, quis facere rerum nulla consequuntur
      tenetur ea nemo recusandae quisquam ex tempora, alias molestiae
      accusantium unde nesciunt ullam quas repudiandae doloribus voluptatibus
      voluptate distinctio. Sit, minus!
    </p>
    <p>
      Assumenda odit mollitia corporis sint quibusdam, facere sapiente labore
      itaque praesentium tempora ad commodi perspiciatis fuga esse recusandae
      vel. Quas possimus sit corrupti dolorem iusto repellat. Rerum nostrum
      totam optio!
    </p>
    <p>
      Eum perspiciatis accusamus in ducimus soluta quidem amet nisi, deleniti
      nihil commodi sapiente quas error odio perferendis illum explicabo
      corporis ex dolorem obcaecati vel laborum ratione totam laudantium.
      Pariatur, animi!
    </p>
  </div>
</template>
<style scoped>
.about {
  margin: 5px 10px;
  text-align: left;
}
</style>
